import { Text } from '@procurify/ui'
import styled from 'styled-components'

export const GlobalSearchRecentsListHeadingStyled = styled(Text)`
  padding: ${(props) => props.theme.space.small}
    ${(props) => props.theme.space.medium};
`
